var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        "ok-disabled": _vm.disableSubmit,
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
        switchFullscreen: "",
        okText: this.$store.getters.language["common.okButton"],
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                model: _vm.model,
                "label-col": _vm.labelCol2,
                "wrapper-col": _vm.wrapperCol2,
                rules: _vm.validatorRules
              }
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["cs.venuecode"],
                            prop: "venuecode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "系统自动生成",
                              disabled: true
                            },
                            model: {
                              value: _vm.model.venuecode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "venuecode", $$v)
                              },
                              expression: "model.venuecode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["cs.venuename"],
                            prop: "venuename"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language["cs.venuename"],
                              maxLength: 100
                            },
                            model: {
                              value: _vm.model.venuename,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "venuename", $$v)
                              },
                              expression: "model.venuename"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["cs.venuestatus"],
                            prop: "status"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "select",
                              dictCode: "cs_venuestatus"
                            },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["cs.venuecategory"],
                            prop: "category"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "select",
                              dictCode: "cs_venuecategory"
                            },
                            model: {
                              value: _vm.model.category,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "category", $$v)
                              },
                              expression: "model.category"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label:
                              _vm.language["labor.contractor.detailAddress"],
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1,
                            prop: "address"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: this.language[
                                "labor.contractor.detailAddress"
                              ],
                              maxLength: 500
                            },
                            model: {
                              value: _vm.model.address,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "address", $$v)
                              },
                              expression: "model.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: this.language["common.uploadPicture"],
                            labelCol: _vm.labelCol1,
                            wrapperCol: _vm.wrapperCol1,
                            prop: "files"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: "上传",
                              isMultiple: true,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.files,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "files", $$v)
                              },
                              expression: "model.files"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.disableSubmit === false
            ? _c(
                "a-tabs",
                {
                  on: { change: _vm.handleChangeTabs },
                  model: {
                    value: _vm.activeKey,
                    callback: function($$v) {
                      _vm.activeKey = $$v
                    },
                    expression: "activeKey"
                  }
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: _vm.refKeys[0],
                      attrs: { tab: "樓層區域設置信息", forceRender: true }
                    },
                    [
                      _c("j-editable-table", {
                        ref: _vm.refKeys[0],
                        attrs: {
                          loading: _vm.children.loading,
                          columns: _vm.columns,
                          dataSource: _vm.children.dataSource,
                          maxHeight: 400,
                          maxNumber: 100,
                          disabled: _vm.formDisabled,
                          rowNumber: true,
                          rowSelection: true,
                          actionButton: true
                        },
                        on: { valueChange: _vm.valueChange }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("language-model", { ref: "languageModel", on: { ok: _vm.languageOk } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }